import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicOption({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 2.73a.75.75 0 00-1.07-.02L3.62 4.45l-.94-.94-.08-.07a.75.75 0 00-.98 1.13l1.45 1.46.09.07c.29.22.7.2.96-.06l2.35-2.25.07-.08a.75.75 0 00-.05-.98zm7.8 1.72c0-.41-.31-.75-.7-.75H8.2a.73.73 0 00-.6.75c0 .41.31.75.7.75h5.4c.34-.06.6-.37.6-.75zm0 3.9c0-.41-.31-.75-.7-.75H6.29a.73.73 0 00-.6.74c0 .42.3.75.7.75l7.21.01h.1c.34-.06.6-.37.6-.75zm-.7 3.16c.39 0 .7.33.7.75 0 .38-.26.69-.6.74H6.39c-.4 0-.7-.34-.7-.75 0-.38.26-.7.6-.74l.1-.01h7.21zm-9.9 1.74a1 1 0 100-2 1 1 0 000 2zm1-4.9a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </svg>
  );
}

SvgBasicOption.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicOption.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicOption svgRef={ref} {...props} />);
export default ForwardRef;
